import { NodeFlags } from "../../hierarchy/common/hierarchy.js";
import { HierarchyNode } from "../../hierarchy/common/hierarchyService.js";

const previewCamera = Symbol("editor-preview-camera");

export function markEditorPreviewCamera(camera: object): void {
    (camera as { [previewCamera]?: boolean })[previewCamera] = true;
}

export function isEditorPreviewCamera(camera: unknown): boolean {
    return !!camera && typeof camera === "object" && (camera as { [previewCamera]?: boolean })[previewCamera] === true;
}

export function isEditorInternalRender(scene: unknown, camera: unknown): boolean {
    return isEditorPreviewCamera(camera) || isEditorInternalScene(scene);
}

/**
 * Whether a render is the EDITOR's own — a preview, an overlay, a thumbnail
 * readback.
 *
 * Those scenes are flagged HideInHierarchy, and everything that reports on the
 * PAGE's frame has to use the same rule or the two disagree: the GPU measurement
 * excluded them while the frame capture did not, so the render graph showed our
 * own work as the page's passes and no card could be paired with a measurement.
 */
export function isEditorInternalScene(scene: unknown): boolean {
    if (!scene || typeof scene !== "object") return false;
    try { return HierarchyNode.hasFlag(scene, NodeFlags.HideInHierarchy); }
    catch { return false; }
}
